import Close from '@mui/icons-material/Close'
import { CardContent, Divider } from '@mui/material'
import { Card, CardHeader, IconButton, Modal } from 'components'

import { useLostProposalModalStore } from './LostProposalModalStore'
import { useLostProposal } from 'modules/orders/hooks'
import { ReasonForm } from 'modules/orders/components/ReasonForm'

export const LostProposalModal = () => {
  const setModalIsOpen = useLostProposalModalStore.useSetModalIsOpen()
  const isModalOpen = useLostProposalModalStore.useIsModalOpen()
  const proposalId = useLostProposalModalStore.useProposalId()

  const { mutate, isLoading } = useLostProposal()

  const handleSubmit = ({
    conceptId,
    details
  }: {
    conceptId: string
    details?: string
  }) => {
    setModalIsOpen(false)
    mutate({ proposalId, conceptId, details: details || '' })
  }

  return (
    <Modal
      open={isModalOpen}
      onClose={() => setModalIsOpen(false)}
      keepMounted={false}
      style={{
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
      }}
    >
      <Card style={{ padding: 0, minWidth: 300, width: 600 }}>
        <CardHeader
          title={`Orçamento n° ${proposalId}`}
          HeaderRight={
            <IconButton onClick={() => setModalIsOpen(false)}>
              <Close />
            </IconButton>
          }
        />
        <Divider />
        <CardContent sx={{ maxHeight: 450, overflowY: 'auto' }}>
          <ReasonForm
            submitLabel="Cancelar Orçamento"
            isLoading={isLoading}
            onSubmit={handleSubmit}
            onCancel={() => setModalIsOpen(false)}
          />
        </CardContent>
      </Card>
    </Modal>
  )
}
